// extracted by mini-css-extract-plugin
export default {"container":"modal-safe_container__-1hlm","draw-path":"modal-safe_draw-path__a3PaM"};